<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-toolbar class="overview-toolbar" flat color="transparent" :height="100">
          <v-toolbar-title>Projects</v-toolbar-title>
          <v-divider class="mx-3" inset vertical />
          <v-btn-toggle v-model="showArchived" mandatory class="hidden-sm-and-down">
            <v-btn flat :value="false">Active ({{ numActiveProjects }})</v-btn>
            <v-btn flat :value="true">Archived ({{ numArchivedProjects }})</v-btn>
          </v-btn-toggle>
          <v-divider class="mx-3 hidden-sm-and-down" inset vertical />
          <v-text-field
            ref="searchInput"
            v-model="searchTerm"
            label="Search"
            clearable
            solo
          />
          <v-spacer />
        </v-toolbar>
      </v-flex>
    </v-layout>

    <v-data-table
      :loading="loadingProjects"
      :headers="tableHeaders"
      :items="tableItems"
      :search="searchTerm"
      class="elevation-1"
      sort-icon="fas fa-sort-alpha-up ml-2"
      must-sort
      hide-actions
    >
      <v-alert
        slot="no-results"
        :value="true"
        color="error"
        icon="fas fa-exclamation-triangle"
      >
        Your search for "{{ searchTerm }}" found no results.
      </v-alert>

      <template slot="items" slot-scope="props">
        <router-link
          tag="tr"
          :to="'/projects/'+props.item.id"
          class="project-list-project"
          tabindex="0"
          @keydown.enter.native="$router.push('/projects/'+props.item.id)"
        >
          <td>
            <v-btn
              :to="'/projects/'+props.item.id"
              color="primary"
              small
              class="mr-3"
              style="vertical-align: middle;"
              tabindex="-1"
            >
              Open
            </v-btn>
            <span class="project-list-project__name">
              {{ props.item.name }}
              <img
                v-if="props.item.ngFlag"
                class="ml-3 ng-flag"
                src="../assets/ngcom-green.svg"
              />
            </span>
          </td>
          <td>
            {{ props.item.date }}
          </td>
          <td>
            {{ props.item.code }}
          </td>
        </router-link>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      searchTerm: '',
      showArchived: false,
    }
  },

  computed: {
    loadingProjects() {
      return this.$store.state.loadingProjects
    },

    projects() {
      return this.$store.getters.sortedProjects
    },

    numActiveProjects() {
      return this.projects.filter(project => !project.archived).length
    },

    numArchivedProjects() {
      return this.projects.filter(project => project.archived).length
    },

    filteredProjects() {
      return this.projects.filter((project) => {
        if (this.showArchived && !project.archived) {
          return false
        }
        if (!this.showArchived && project.archived) {
          return false
        }
        return true
      })
    },

    tableHeaders() {
      return [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Date',
          value: 'Project date',
        },
        {
          text: 'Code',
          value: 'code',
        },
      ]
    },

    tableItems() {
      return this.filteredProjects
    },
  },

  watch: {
    showArchived() {
      localStorage.projects_showArchived = JSON.stringify(this.showArchived)
    },
    projects() {
      if (this.projects.length === 1) {
        this.$router.push({ name: 'project', params: { id: this.projects[0].id } })
      }
    },
  },

  created() {
    if (localStorage.projects_showArchived) {
      this.showArchived = JSON.parse(localStorage.projects_showArchived)
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.$refs.searchInput.focus()
      }
    })
  },
}
</script>

<style scoped>
.project-list-project {
  cursor: pointer;
}

.project-list-project__name {
  display: inline-block;
  vertical-align: middle;
}
</style>
